<template>
    <div class="wapper">
        <el-page-header @back="goBack" :content="id ? '编辑发票' : '申请发票'" class="header">
        </el-page-header>
        <div class="rightInfo" v-if="totalApplyInvoiceExact">
            <div>{{ surplusInvoiceAmount }}元</div>
            <div style="font-weight: normal;">剩余可申请金额</div>
        </div>
        <div class="info">
            <span class="title">开票提醒</span>
            <ul>
                <li>1、只有已完成的订单才可开具发票，每个订单可一次性全部开具发票，也可分多次部分开具发票；</li>
                <li>2、同一订单开具的所有发票抬头必须保持一致；</li>
                <li>3、发票内容取所选开票订单所属卡类型、合约公司可开票内容交集（如果是积分订单，则只取合约公司的可开票内容），为避免开票内容为空，故开票时建议按储值/充值/积分订单选择同类型卡订单进行开票；</li>

            </ul>
        </div>
        <el-form :model="info" label-width="100px" ref="ruleForm" class="form-wapper">
            <el-card class="box-card">
                <div slot="header">
                    索取开票信息
                    <font class="msg">* 客户名称和合约公司为必选项</font>
                </div>
                <el-row :gutter="20" :disabled="lock">
                    <el-col :span="6">
                        <el-form-item label="客户名称" class="required">
                            <el-select :disabled="lock" placeholder="请选择" filterable v-model="info.customerId">
                                <el-option v-for="item in customer" :key="item.customerId" :label="item.customerName"
                                    :value="item.customerId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="合约公司" class="required">
                            <el-select :disabled="lock" placeholder="请选择" v-model="info.companyId">
                                <el-option v-for="item in contractCompany" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="订单编号" width="100">
                            <el-input :disabled="lock" v-model="info.orderNo" placeholder="请输入订单编号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="订单类型">
                            <Select :type="'OrderTypeNewEnum'" :placeholder="'订单类型'" :disabled="lock"
                                @change="OrderTypeChange"></Select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" style="text-align:left;margin-left:0;">
                        <el-form-item>
                            <el-button plain :disabled="lock" @click="select">查询</el-button>
                            <el-button plain :disabled="lock" @click="reset">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>
        </el-form>

        <el-card class="box-card" header="可开票订单列表" v-if="tableData.length > 0">
            <el-table :data="tableData" ref="multipleTable" @selection-change="selectionChange">
                <el-table-column type="selection" :selectable="selectable" width="55">
                </el-table-column>
                <el-table-column prop="customerName" label="客户名称" width="150">
                </el-table-column>
                <el-table-column prop="orderNo" width="120" label="订单编号">
                </el-table-column>
                <el-table-column prop="orderTypeName" label="订单类型">
                </el-table-column>
                <el-table-column label="回款总额">
                    <template slot-scope="scope">
                        {{ $numberUtils.divide(Number(scope.row.returnAmount), 100) || 0 }}
                    </template>
                </el-table-column>
                <el-table-column label="退售回款额">
                    <template slot-scope="scope">
                        {{ $numberUtils.divide(Number(scope.row.refundReturnAmount), 100) || 0 }}
                    </template>
                </el-table-column>
                <el-table-column label="可开票总额">
                    <template slot-scope="scope">
                        {{ $numberUtils.divide(Number(scope.row.totalInvoiceAmount), 100) || 0 }}
                    </template>
                </el-table-column>
                <el-table-column label="已开票金额">
                    <template slot-scope="scope">
                        {{ $numberUtils.divide(Number(scope.row.usedInvoiceAmount), 100) || 0 }}
                    </template>
                </el-table-column>
                <el-table-column label="剩余可开票总额" width="150">
                    <template slot-scope="scope">
                        {{ $numberUtils.divide(Number(scope.row.leftInvoiceAmount), 100) || 0 }}
                    </template>
                </el-table-column>
                <el-table-column label="本次开票金额" width="200">
                    <template slot-scope="scope">
                        <div class="partial-invoice">
                            <span v-if="!scope.row.partialInvoice">{{ scope.row.leftInvoiceAmountExact }}</span>
                            <div style="display:none">
                                {{ scope.row }}
                            </div>
                            <el-button :disabled="lock || !scope.row.isSelected" size="mini"
                                v-if="!scope.row.partialInvoice" @click="() => { scope.row.partialInvoice = true }"
                                type="primary">部分开票</el-button>

                            <el-input size="mini" v-if="scope.row.partialInvoice" :min="0" :disabled="lock"
                                @input="() => { checkInputValue(scope.row, 'leftInvoiceAmountNew', scope.row.leftInvoiceAmountExact) }"
                                v-model="scope.row.leftInvoiceAmountNew" width="100"></el-input>
                            <el-button :disabled="lock" size="mini" v-if="scope.row.partialInvoice"
                                @click="scope.row.partialInvoice = false" type="warning">取消</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="70">
                    <template slot-scope="scope">
                        <el-button @click="toDetail(scope.row)" type="text" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="bottom" v-if="hasTableSelect">
                <div class="bottom-info">是否确认对选中的订单进行开票？</div>
                <el-button type="primary" size="mini" :disabled="lock" @click="onSure">确认</el-button>
                <el-button size="mini" @click="onCannel">取消</el-button>
                <div class="total" v-if="Number(totalApplyInvoiceExact) > 0">
                    <span>本次开票金额合计:</span>
                    <span style="color:#ff5e5e;">{{ totalApplyInvoiceExact }}</span>
                </div>
            </div>
        </el-card>

        <el-card class="box-card" header="客户发票信息" v-if="lock">
            <el-form label-width="120px" ref="ruleForm" class="form-wapper">
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="发票类型：" required>
                            <el-select v-model="companyCustomerInvoiceDetail.invoiceTypeId" filterable placeholder="请选择">
                                <el-option v-for="item in contractCompanyInvoiceData" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="showInvoiceDetail" label="纳税人识别号：">
                            <el-input readonly v-model="invoiceDetail.taxpayerCode"></el-input>
                        </el-form-item>
                        <el-form-item v-if="showInvoiceDetail" label="公司注册电话：">
                            <el-input readonly v-model="invoiceDetail.companyPhone"></el-input>
                        </el-form-item>
                        <el-form-item v-if="showInvoiceDetail" label="开户行账号：">
                            <el-input readonly v-model="invoiceDetail.companyBankAccount"></el-input>
                        </el-form-item>
                        <el-form-item label="接收人邮箱：" required v-if="showEmailMobile">
                            <el-input v-model="companyCustomerInvoiceDetail.receiverEmail"
                                placeholder="请填写接收人邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item required label="发票抬头：">
                            <el-select v-model="companyCustomerInvoiceDetail.invoiceTitleId" filterable placeholder="请选择"
                                @change="invoiceTitleSelect">
                                <el-option v-for="item in customerInvoiceTitleData" :key="item.id"
                                    :label="item.invoiceTitle" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="showInvoiceDetail" label="公司注册地址：">
                            <el-input readonly v-model="invoiceDetail.companyAddress"></el-input>
                        </el-form-item>
                        <el-form-item v-if="showInvoiceDetail" label="开户行名称：">
                            <el-input readonly v-model="invoiceDetail.companyBankName"></el-input>
                        </el-form-item>
                        <el-form-item required label="接收人手机号：" v-if="showEmailMobile">
                            <el-input maxlength="11" v-model="companyCustomerInvoiceDetail.receiverPhone"
                                placeholder="请填写接收人手机号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <el-card class="box-card"
            v-if="lock && companyCustomerInvoiceDetail.invoiceTypeId && companyCustomerInvoiceDetail.invoiceTitleId">
            <div slot="header">
                开票信息
                <font class="msg">说明：如果单张发票开具发票内容条数超过15条，请删除所有发票内容，只需在对应的发票下上传发票内容附件即可</font>
            </div>
            <el-form label-width="120px" class="form-wapper">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="开票公司：">
                            <el-input v-if="companyData" readonly v-model="companyData.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="合约开票总额：">
                            <el-input readonly v-model="totalApplyInvoiceExact"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="单张开票最大额：">
                            <el-input readonly v-model="maxInvoicedAmount"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="table-title" style="">
                发票信息（带 * 为必填项，其他信息根据必要需求填写）
                <el-button size="small" style="float:right" @click="addContentBase" type="primary">添加发票</el-button>
            </div>
            <table v-for="(contentBase, index) in contentBaseList" :key="index" class="invoice-table">
                <thead>
                    <tr>
                        <th>* 发票内容</th>
                        <th>规格型号</th>
                        <th>单位</th>
                        <th>* 数量</th>
                        <th width="100">单价</th>
                        <th width="150">* 开票金额（含税）</th>
                        <th width="80">操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><el-input size="small" v-model="contentBase.contentListItem.invoiceContent"></el-input></td>
                        <td><el-input size="small" v-model="contentBase.contentListItem.standard"></el-input></td>
                        <td><el-input size="small" v-model="contentBase.contentListItem.unit"></el-input></td>
                        <td>
                            <el-input size="small" v-model="contentBase.contentListItem.count" type="number"
                              @change="countChange($event, contentBase)">
                            </el-input>
                        </td>
                        <td></td>
                        <td><el-input size="small"
                                @input="() => { checkInputValue(contentBase.contentListItem, 'invoiceAmount') }"
                                v-model="contentBase.contentListItem.invoiceAmount"></el-input></td>
                        <td><el-button :disabled="contentBase.file.fileUrl ? true : false" type="primary"
                                @click="addInvoice(contentBase, index)" size="mini">添加</el-button>
                        </td>
                    </tr>
                    <template v-for="(invoice, i) in contentBase.contentList">
                        <tr v-if="!invoice.disabled" :key="i">
                            <td>
                                <div style="text-align: left;">{{ invoice.invoiceContent }}</div>
                            </td>
                            <td>
                                <div>{{ invoice.standard }}</div>
                            </td>
                            <td>
                                <div>{{ invoice.unit }}</div>
                            </td>
                            <td>
                                <div>{{ invoice.count }}</div>
                            </td>
                            <td>
                                <div>{{ invoice.price }}</div>
                            </td>
                            <td>
                                <div>{{ invoice.invoiceAmount }}</div>
                            </td>
                            <td><el-button type="danger" @click="delInvoice(contentBase.contentList, invoice, i)"
                                    size="mini">删除</el-button></td>
                        </tr>
                    </template>
                    <tr v-if="contentBase.file.fileUrl">
                        <td colspan="5">
                            <a :href="contentBase.file.fileUrl" target="_blank">发票附件（详情见附件清单）{{ contentBase.file.fileName
                            }}</a>
                        </td>
                        <td>
                            {{ contentBase.file.invoiceAmount }}
                        </td>
                        <td>
                            <el-button type="danger" @click="delFile(contentBase)" size="mini">删除</el-button>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            <el-input type="textarea" resize="none" rows="3" placeholder="请输入内容"
                                v-model="contentBase.remark">
                            </el-input>
                        </td>
                        <td colspan="3" class="caozuo">
                            <el-button v-if="contentBaseList.length > 1" type="danger"
                                @click="delInvoiceBase(contentBase, index)" size="mini">删除发票</el-button>
                            <el-button type="primary" @click="uploadInvoice(contentBase, index)"
                                size="mini">上传发票</el-button>
                            <div>
                                <a :href="contentBase.file.fileUrl" target="_blank">{{ contentBase.file.fileName }}</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </el-card>
        <el-button style="width:100%;margin-top:20px" type="primary" v-if="Number(surplusInvoiceAmount) == 0 && lock"
            @click="submit">确认开票</el-button>
        <el-dialog title="导入发票内容" destroy-on-close :visible.sync="dialogVisible" width="50%">
            <div class="info">
                <span>温馨提醒</span>
                <span>1、上传导入文件必须是 .xls或 .xlsx格式</span>
                <span>2、请严格按照导入模板格式处理数据，确保上传的文档中无空格等特殊字符；</span>
                <span>3、附件中 明细-金额 之和必须 ≤ 单张开票最大额，如果超出限额，请添加第二张发票并上传第二张发票的内容附件；</span>
                <span>4、每张发票只能上传一个附件，如果重复上传，则直接覆盖上一次上传的附件；</span>
            </div>
            <div class="one">
                <span>Step1：下载文档模板，按照要求处理数据</span>
                <el-button @click="downloadFileTpl()" size="small">下载模板</el-button>
            </div>
            <div class="two">
                <span>Step2：导入处理好的数据文档</span>
                <input @change="fileChange($event)" type="file"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="!canImport" @click="submitImport">确认导入</el-button>
            </span>
        </el-dialog>

        <el-dialog title="确认提交提醒" destroy-on-close :visible.sync="dialogInvoiceVisible" width="50%">
            <div class="tips">
                你提交的开票申请中含有特殊发票内容,<span v-for="(item,index) in checkSpecialInvoice.list">{{ item}} <i v-show="index < checkSpecialInvoice.list.length - 1">、</i></span>，如非必要，可返回修改为其他发票内容，如确认提交，该申请需要过公司高级别领导审核，是否确认提交？
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogInvoiceVisible = false">返回修改</el-button>
                <el-button type="primary"  @click="onSubmit">确认提交</el-button>
            </span>
        </el-dialog>

         <el-dialog title="确认导入提醒" destroy-on-close :visible.sync="dialogInvoiceImportVisible" width="50%">
            <div class="tips">
                你导入的开票申请附件中含有特殊发票内容,<span v-for="(item,index) in checkSpecialInvoiceFile.list">{{ item}} <i v-show="index < checkSpecialInvoiceFile.list.length - 1">、</i></span>，如非必要，可返回修改为其他发票内容后重新导入，如确认导入，该申请需要过公司高级别领导审核，是否确认导入？
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="invoiceImporBack">返回重新导入</el-button>
                <el-button type="primary"  @click="dialogInvoiceImportVisible = false">确认导入</el-button>
            </span>
        </el-dialog>


    </div>
</template>
<script>
import _request from '@/utils/request.js'
import _tax from '@/service/tax-service'
import _invoice_company from '@/service/invoice-company-service'
import Select from '@/views/common/Select'
import AddInvoiceTempate from './common/addInvoicTempate.vue'
import { phoneReg, emailReg } from '@/utils/reg.js'
const contentListItem = {
    count: '',
    invoiceAmount: '',
    invoiceContent: '',
    standard: '',
    unit: ''
}

export default {
    data() {
        window.VUE = this;
        const route = this.$route
        let id = (route.query && route.query.id) || ''
        return {
            id: id,
            totalApplyInvoiceExact: '',
            surplusInvoiceAmount: '',
            lock: false,
            contractCompany: [],
            customer: [],
            info: {
                companyId: '',
                customerId: '',
                orderNo: '',
                orderType: '',
            },

            invoiceList: [],

            tableData: [],

            hasTableSelect: false,

            customerInvoiceTitleData: [],
            contractCompanyInvoiceData: [],
            companyCustomerInvoiceDetail: {
                invoiceTypeId: '',
                invoiceTitleId: '',
                receiverPhone: '',
                receiverEmail: ''
            },
            contractCompanyDetail: {},
            invoiceContent: {},
            contentBaseList: [

            ],
            contentBaseItem: {
                contentListItem: Object.assign({}, contentListItem),
                contentList: [],
                file: {}
            },
            dialogVisible: false,
            canImport: false,
            file: {},
            dialogInvoiceVisible: false,
            dialogInvoiceImportVisible:false,
            checkSpecialInvoice: {},
            checkSpecialInvoiceFile:{},
            data: {},
            specialFlag: [],
        }
    },
    computed: {

        showEmailMobile() {
            return this.companyCustomerInvoiceDetail.invoiceTypeId == 3 || this.companyCustomerInvoiceDetail.invoiceTypeId == 4 || this.companyCustomerInvoiceDetail.invoiceTypeId == 5 || this.companyCustomerInvoiceDetail.invoiceTypeId == 6
        },
        showInvoiceDetail() {
            return this.companyCustomerInvoiceDetail.invoiceTitleId ? true : false
        },
        invoiceDetail() {
            let data = {};
            for (const invoice of this.customerInvoiceTitleData) {
                if (invoice.id == this.companyCustomerInvoiceDetail.invoiceTitleId) {
                    data = Object.assign({}, invoice)
                }
            }
            return data
        },
        companyData() {
            return this.contractCompany.find(item => {
                return item.id == this.info.companyId
            })
        },
        customerData() {
            return this.customer.find(item => {
                return item.customerId == this.info.customerId
            })
        },
        maxInvoicedAmount() {
            let maxAmount = 0;
            let id = this.companyCustomerInvoiceDetail.invoiceTypeId
            if (this.invoiceContent && this.invoiceContent.invoiceAmountInfo) {
                let data = this.invoiceContent.invoiceAmountInfo.find(i => {
                    return i.type == id
                })
                console.log(data, id, 'data------')
                if (data) {
                    maxAmount = data.amount / 100
                }
            }
            return maxAmount
        }
    },
    components: {
        Select,
        AddInvoiceTempate
    },
    methods: {
        countChange(e, row) {
            if (e) {
                e = e.replace(/[^0-9]/g,'')
                this.$set(row.contentListItem, 'count', e)
            }
        },
        invoiceTitleSelect() {
            if (this.companyCustomerInvoiceDetail.invoiceTypeId == 2 || this.companyCustomerInvoiceDetail.invoiceTypeId == 4 ) {
                if (!this.invoiceDetail.companyAddress || !this.invoiceDetail.companyBankName || !this.invoiceDetail.companyPhone || !this.invoiceDetail.companyBankAccount) {
                    this.$message.error({ message: '专票类型的发票抬头所有信息不可为空，请先完善发票抬头' })
                    return false
                }
            }

        },
        OrderTypeChange(val) {
            this.info.orderType = val
        },
        downloadFileTpl() {
            location.href = 'https://rs.juyoufuli.com/static/excel/%E5%BC%80%E7%A5%A8%E7%94%B3%E8%AF%B7%E5%8D%95%E4%B8%8A%E4%BC%A0%E5%8F%91%E7%A5%A8%E5%86%85%E5%AE%B9%E9%99%84%E4%BB%B6.xlsx'
        },
        goBack() {
            this.$router.back()
        },
        getContractCompanyInvoice() {
            _tax.getContractCompanyInvoiceType({ companyId: this.info.companyId }, response => {
                this.contractCompanyInvoiceData = response
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
        },

        select() {
            if (!this.info.customerId) {
                this.$message.error('请选择要开票的客户名称');
                return false
            }
            if (!this.info.companyId) {
                this.$message.error('请选择合约公司');
                return false
            }
            if (this.info.orderNo) {
                if (!this.info.orderType) {
                    this.$message.error('请选择订单类型');
                    return false
                }
            }
            _tax.getInvoiceApplyOrderList(this.info, response => {
                response.forEach(item => {
                    this.$set(item, 'partialInvoice', false)
                    this.$set(item, 'leftInvoiceAmountNew', 0)
                })
                this.tableData = response
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
        },
        reset() {
            window.location.reload()
        },
        selectable(row, rowIndex) {
            if (!this.lock) {
                return true
            }
        },
        selectionChange(selection) {
            console.log(this.$refs.multipleTable, selection, 'selection...............')
            const selectIds = [];
            for (const item of selection) {
                selectIds.push(item.orderNo)
                item.isSelected = true
            }
            for (const item of this.tableData) {
                if (selectIds.indexOf(item.orderNo) < 0) {
                    item.partialInvoice = false;
                    item.isSelected = false
                }
            }
            this.hasTableSelect = (selection.length > 0)
        },
        checkInputValue(row, key, max) {
            let leftInvoiceAmountNew = row[key];
            let value = leftInvoiceAmountNew;
            value = value.replace(/[^\d.]/g,"");//清除"数字"和"."以外的字符
            value = value.replace(/^\./g,"");//验证第一个字符是数字而不是字符
            value = value.replace(/\.{2,}/g,".");//只保留第一个.清除多余的
            value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
            if (max && Number(value) > max) {
                value = max
            }
            row[key] = value;
        },
        toDetail(row) {
            if (row.orderType == 3) {
                window.open(_request.getCrmBaseUrl(`/integral-order-detail?orderNo=${row.orderNo}`))
                return
            }

            if (row.orderType == 2) {
                window.open(_request.getCrmBaseUrl(`/recharge-order-detail?id=${row.orderNo}`))
                return
            }
            if (row.orderType == 5) {
                window.open(_request.getCrmBaseUrl(`/purchase-order-detail?orderNo=${row.orderId}`))
                return
            }
            if (row.orderType != 3 && row.storedOrderType == 1){
                window.open(_request.getCrmBaseUrl(`/stored-order-detail?id=${row.orderNo}`))
                return
            }
            if (row.orderType != 3 && row.storedOrderType == 2){
                window.open(_request.getCrmBaseUrl(`/stored-order-custom-detail?id=${row.orderNo}`))
                return
            }
        },
        enterPartialInvoice(scope) {
            console.log(scope, 'scope......')
        },
        onCannel() {
            this.companyCustomerInvoiceDetail.invoiceTitleId = ''
            this.companyCustomerInvoiceDetail.invoiceTypeId = ''
            this.companyCustomerInvoiceDetail.receiverEmail = ''
            this.companyCustomerInvoiceDetail.receiverPhone = ''
            this.contentBaseList = [];
            this.addContentBase()
            this.lock = false
        },
        onSure() {
            let table = this.$refs.multipleTable;
            let selection = table.selection;
            if (selection <= 0) {
                this.$message.error('请选择开票的订单数据');
                return false
            }
            let customerIds = [];
            let ordersMap = {};
            for (const item of selection) {
                customerIds.push(item.customerId);
                const contractCompanyId = item.contractCompanyId
                const orderData = {
                    ...item,
                }
                orderData.leftInvoiceAmountNew = Number(item.leftInvoiceAmountNew)
                if (ordersMap[contractCompanyId]) {
                    ordersMap[contractCompanyId].orderInfos.push(orderData)
                } else {
                    ordersMap[contractCompanyId] = {
                        contractCompanyId: contractCompanyId,
                        orderInfos: [orderData]
                    }
                }
                let isLing = false

                if (item.partialInvoice && Number(item.leftInvoiceAmountNew) <= 0) {
                    isLing = true
                }
                if (!item.partialInvoice && Number(item.leftInvoiceAmountExact) <= 0) {
                    isLing = true
                }

                if (isLing) {
                    this.$message.error('选择开票订单数据：' + item.orderNo + '开票金额不能为0');
                    return false
                }

            }

            // 理论不会出现 不同的客户
            if (new Set(customerIds).size > 1) {
                this.$message.error('请选择相同客户进行开票');
                return false
            }

            this.lock = true

            _tax.getCustomerInvoice({ customerId: customerIds[0] }, res => {
                this.customerInvoiceTitleData = res.dataList
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
          _invoice_company.getContractCompanyDetail(this.info.companyId, res => {
                this.contractCompanyDetail = res
                }, response => {
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })

            this.getContractCompanyInvoice();

            let orders = [];
            for (const key in ordersMap) {
                orders.push(ordersMap[key])
            }
            _tax.getInvoiceContentList(orders, response => {
                this.invoiceContent = response[0]
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })

            })

            this.checkAmount()

        },
        invoiceImporBack() {
            let len = this.contentBaseList.length
            if (len > 1) {
                this.contentBaseList.splice(len-1,1)
            } else {
                this.contentBaseList = [];
                this.addContentBase()
            }
           this.dialogInvoiceImportVisible=false
        },
        checkAmount(succ, err) {
            let orderAmountList = [];
            let invoiceAmountList = [];
            let table = this.$refs.multipleTable;
            let selection = table.selection;

            for (const order of selection) {
                if (order.partialInvoice) {
                    orderAmountList.push(order.leftInvoiceAmountNew)
                } else {
                    orderAmountList.push(order.leftInvoiceAmountExact)
                }
            }

            for (const contentBase of this.contentBaseList) {
                for (const invoiceContent of contentBase.contentList) {
                    invoiceAmountList.push(Number(invoiceContent.invoiceAmount))
                }
                if (contentBase.file && contentBase.file.fileUrl) {
                    invoiceAmountList.push(contentBase.file.invoiceAmount)
                }
            }
            var datas = {
                orderAmountList: orderAmountList,
                invoiceAmountList: invoiceAmountList
            }


            _tax.getSurplusInvoiceAmount(datas, response => {
                this.totalApplyInvoiceExact = response.totalInvoicedAmount
                this.surplusInvoiceAmount = response.surplusInvoiceAmount
                if (invoiceAmountList.length == 0) {
                    this.surplusInvoiceAmount = this.totalApplyInvoiceExact;
                    return;
                }
                if (succ) {
                    succ(response)
                }
            }, response => {
                if (err) {
                    err(response)
                }
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
        },
        addContentBase() {
            // this.contentBaseItem = {}
            this.contentBaseList.push(JSON.parse(JSON.stringify(this.contentBaseItem)))
        },
        addInvoice(contentBase, index) {

            let { invoiceContent, count, invoiceAmount } = contentBase.contentListItem

            if (!String(invoiceContent).trim()) {
                this.$message.error('请填写发票内容');
                return
            }
            if (!String(count).trim()) {
                this.$message.error('请填写数量');
                return
            }
            if (String(count) == 0) {
                this.$message.error('数量不能为0');
                return
            }
            if (!String(invoiceAmount).trim()) {
                this.$message.error('请填写金额');
                return
            }

            let maxAmount = this.maxInvoicedAmount;
            for (const item of contentBase.contentList) {
                maxAmount -= item.invoiceAmount
            }
            if (invoiceAmount > maxAmount) {
                this.$message.error('超出单张发票最大金额');
                return
            }
            _tax.getUnitPrice({ count: count, invoiceAmount: invoiceAmount }, res => {
                let data = Object.assign({}, contentBase.contentListItem);
                data.price = res;
                data.disabled = true
                contentBase.contentList.push(data)
                this.checkAmount(res => {
                    data.disabled = false
                    for (const key in contentBase.contentListItem) {
                        contentBase.contentListItem[key] = "";
                    }
                }, err => {
                    let len = contentBase.contentList.length || 0
                    contentBase.contentList.splice(len - 1, 1)
                })
            }, err => {

            })
        },


        delInvoice(list, invoice, index) {
            list.splice(index, 1);
            this.checkAmount()
        },
        delInvoiceBase(contentBase, index) {
            this.contentBaseList.splice(index, 1);
            this.checkAmount()
        },
        uploadInvoice(contentBase, index) {
            if (contentBase.contentList.length > 0) {
                this.$message.error('已有发票内容，如果上传附件，请删除所有发票内容后上传');
                return
            }
            window.contentBase = contentBase
            this.dialogVisible = true
        },
        fileChange(e) {
            let file = e.target.files[0]
            let maxAmount = this.maxInvoicedAmount || 0;
            let _loading = this.$loading({ fullscreen: true })
            _tax.uploadFile(
                file,
                maxAmount,
                response => {
                    _loading.close()
                    this.$notify({
                        message: '上传成功',
                        type: 'warning'
                    })
                    this.file.fileName = response.fileName
                    this.file.fileUrl = response.fullFileUrl
                    this.file.invoiceAmount = response.totalAmount
                    this.canImport = true
                    _tax.checkBatchFinance(file, response => {
                        this.checkSpecialInvoiceFile = response
                        if (this.checkSpecialInvoiceFile.state == 1) {
                            this.file.specialFlag = 1
                        } else {
                            this.file.specialFlag=0
                        }
                    })
                    console.log(this.file)

                }, response => {
                    _loading.close()
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                    this.canImport = false
                })
        },
        submitImport() {
            if (this.file.specialFlag == 1) {
                this.dialogInvoiceImportVisible = true
            }

            window.contentBase.contentList = [];
            window.contentBase.file = { ...this.file };
            this.checkAmount(res=>{
                this.dialogVisible = false
                window.contentBase = null
                this.file = {};
            },err=>{
                window.contentBase.file = {}
            })

        },
        delFile(contentBase) {
            contentBase.file = {}
        },
        submit() {
            if (Number(this.surplusInvoiceAmount) !== 0) {
                this.$message.error({ message: '开票金额之和必须等于合约开票总额' })
                return
            }
            if (this.companyCustomerInvoiceDetail.invoiceTypeId == 2 || this.companyCustomerInvoiceDetail.invoiceTypeId == 4 ) {
                if (!this.invoiceDetail.companyAddress || !this.invoiceDetail.companyBankName || !this.invoiceDetail.companyPhone || !this.invoiceDetail.companyBankAccount) {
                    this.$message.error({ message: '专票类型的发票抬头所有信息不可为空，请先完善发票抬头' })
                    return
                }
            }

            let data = {
                totalApplyInvoiceExact: this.totalApplyInvoiceExact,
                customerId: this.info.customerId,
                customerName: this.customerData.customerName,
                customerInvoiceId: this.companyCustomerInvoiceDetail.invoiceTitleId,
                customerInvoiceName: this.invoiceDetail.invoiceTitle,

            }
            let reOrderList = [];
            const table = this.$refs.multipleTable;
            const selection = table.selection;
            for (const order of selection) {
                reOrderList.push({
                    orderId: order.orderId,
                    orderType: order.orderType,
                    orderNo: order.orderNo,
                    invoiceReOrderId: order.invoiceReOrderId,
                    invoiceApplyAmountExact: order.partialInvoice ? order.leftInvoiceAmountNew : order.leftInvoiceAmountExact,
                    storedOrderType: order.orderType == 1 ? order.orderType : 0
                })
            }
            data.reOrderList = reOrderList
            let receiverPhone = ""
            let receiverEmail = ""
            if (this.companyCustomerInvoiceDetail.invoiceTypeId == 3 || this.companyCustomerInvoiceDetail.invoiceTypeId == 4 || this.companyCustomerInvoiceDetail.invoiceTypeId == 5 || this.companyCustomerInvoiceDetail.invoiceTypeId == 6) {
                receiverPhone = this.companyCustomerInvoiceDetail.receiverPhone
                receiverEmail = this.companyCustomerInvoiceDetail.receiverEmail
            }else{
                receiverPhone = ""
                receiverEmail = ""
            }

            if (this.showEmailMobile) {
                if (!receiverPhone || !phoneReg.test(receiverPhone)) {
                    this.$message.error({ message: '开票信息接收人手机号不正确' })
                    return
                }
                if (!receiverEmail || !emailReg.test(receiverEmail)) {
                    this.$message.error({ message: '开票信息接收人邮箱不正确' })
                    return
                }
            }

            let invoiceListItem = {
                companyId: this.info.companyId,
                companyName: this.companyData.name,
                invoiceType: this.companyCustomerInvoiceDetail.invoiceTypeId,
                totalInvoiceExact: this.totalApplyInvoiceExact,
                maxAmountEach: this.maxInvoicedAmount,
                receiverPhone: receiverPhone,
                receiverEmail: receiverEmail,
            }
            let contentBaseList = [];

            for (const contentBase of this.contentBaseList) {
                let contentList = contentBase.contentList
                if((!contentBase.file || !contentBase.file.fileUrl) && (!contentList ||  contentList.length<=0)){
                    continue;
                }
                let contentBaseData = {
                    remark: contentBase.remark,
                };

                if (contentBase.file && contentBase.file.fileUrl) {
                    contentBaseData.uploadType = 2;
                    const { fileUrl, fileName, invoiceAmount,specialFlag } = contentBase.file
                    contentBaseData.fileUrl = fileUrl;
                    contentBaseData.fileName = fileName;
                    contentBaseData.invoiceAmount = invoiceAmount;
                    contentBaseData.contentList = [{ invoiceAmount: invoiceAmount }];
                    contentBaseData.specialFlag = specialFlag?'1':'0'
                } else {
                    contentBaseData.uploadType = 1;
                    if (contentList && contentList.length > 0) {
                        let list = [];
                        for (const item of contentList) {
                            list.push({
                                count: item.count,
                                invoiceAmount: item.invoiceAmount,
                                invoiceContent: item.invoiceContent,
                                invoiceContentId: item.invoiceContentId,
                                standard: item.standard,
                                unit: item.unit,
                            })
                        }
                        contentBaseData.contentList = list
                    }
                }
                contentBaseList.push({
                    ...contentBaseData
                })
            }
            invoiceListItem.contentBaseList = contentBaseList;
            data.invoiceList = [invoiceListItem];
            if(this.id){
                data.id = this.id
            }



            this.specialFlag=[]

            _tax.checkSpecialInvoiceContent(data, response => {

                this.checkSpecialInvoice = response

                if (this.checkSpecialInvoice.state == 1) {
                    this.specialFlag.push('1')
                    this.dialogInvoiceVisible = true
                } else {
                    this.specialFlag.push('0')
                    this.onSubmit()
                }
            }, response => {
                this.$message({
                    message: response
                });
            })

            this.data = data

        },
        onSubmit() {
            if (this.data.invoiceList.length > 0) {
                this.data.invoiceList.forEach(item => {
                    if (item.contentBaseList.length > 0) {
                        item.contentBaseList.forEach(ite => {
                            if (ite.uploadType == 2) {
                                if (ite.specialFlag == '1') {
                                    this.specialFlag.push('1')
                                } else {
                                    this.specialFlag.push('0')
                                }

                            }
                        })
                    }

                })
            }


            if (this.specialFlag.indexOf('1') > -1) {
                this.data.specialFlag=1
            } else {
                this.data.specialFlag=0
            }


            _tax.createOrUpdate(this.data, response => {
                this.$router.push({
                    path: '/invoice-manage-list'
                })
            }, response => {
                // location.reload()
                this.$notify({
                    message: response,
                    type: 'warning'
                })


            })
        },
        getDetail() {
            _tax.invoiceApplyGetDetail(
                { id: this.id },
                response => {
                    console.log(response, 'response......')
                    const { customerId, companyId, reOrderList, totalApplyInvoiceExact, invoiceList, invoiceTitleInfo } = response;
                    this.totalApplyInvoiceExact = totalApplyInvoiceExact
                    this.info.customerId = customerId;
                    this.info.companyId = companyId;
                    this.lock = true

                    for (const order of reOrderList) {
                        let { invoiceApplyAmountExact, leftInvoiceAmountExact } = order;
                        order.partialInvoice = true
                        order.leftInvoiceAmountNew = invoiceApplyAmountExact
                    }

                    this.tableData = JSON.parse(JSON.stringify(reOrderList));
                    this.$nextTick(() => {
                        for (const order of this.tableData) {
                            this.$refs.multipleTable.toggleRowSelection(order);
                            order.partialInvoice = true
                        }
                    })
                    this.$nextTick(() => {
                        this.onSure()
                    })

                    this.companyCustomerInvoiceDetail.invoiceTypeId = invoiceList[0]['invoiceType']
                    this.companyCustomerInvoiceDetail.invoiceTitleId = invoiceTitleInfo.id
                    this.companyCustomerInvoiceDetail.receiverEmail = invoiceList[0]['receiverEmail']
                    this.companyCustomerInvoiceDetail.receiverPhone = invoiceList[0]['receiverPhone']


                    let _contentBaseList = invoiceList[0].contentBaseList;
                    let contentBaseList = []
                    if(_contentBaseList && _contentBaseList.length>0){
                        for (const _contentBase of _contentBaseList) {
                            let contentBase = JSON.parse(JSON.stringify(this.contentBaseItem));
                            if(_contentBase.uploadType == 2 && _contentBase['contentList'][0]){
                                let file = _contentBase['contentList'][0];
                                contentBase.file = {
                                    invoiceAmount:file.invoiceAmount,
                                    fileUrl:_contentBase.fileUrl,
                                    fileName:_contentBase.fileName,
                                }
                            }
                            if(_contentBase.uploadType == 1 && _contentBase['contentList']){
                                let contentList = _contentBase['contentList']
                                contentBase.contentList = [];
                                for (const item of contentList) {
                                    contentBase.contentList.push({
                                        ...item
                                    })
                                }
                            }
                            contentBaseList.push(contentBase)
                        }
                    }
                    this.contentBaseList = contentBaseList
                    // data.tableData = response.reOrderList
                    // let editData = response
                    // data.editData = response
                    // data.info.customerId = response.customerId
                    // response.invoiceList.forEach((item, i) => {
                    //     data.info.companyId = item.companyId
                    // })
                    // multipleTable.value.toggleAllSelection()
                    // //本次开票金额
                    // data.totalAmount = 0
                    // data.tableData.forEach(item => {
                    //     data.totalAmount += root.$numberUtils.divide(item.leftInvoiceAmount, 100)
                    //     root.$set(item, 'inputShow', true)
                    // })
                    // //编辑实时计算
                    // data.rightTotal = 0
                    // data.editData.invoiceList.forEach(item => {
                    //     item.contentBaseList.forEach((ite) => {
                    //         ite.contentList.forEach((it) => {
                    //             data.rightTotal += root.$numberUtils.divide(it.invoiceAmount, 100)

                    //         })
                    //     })
                    // })
                    // //选择的数据
                    // onSure(true, id, editData)

                }, response => {
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })
        },
        int() {
            if (this.id) {
                this.getDetail()
            } else {
                this.addContentBase()
            }
            _tax.getContractCompany('', response => {
                this.contractCompany = response
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
            _tax.queryCustomerByUser('', response => {
                this.customer = response
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
        }
    },
    created() {
        this.int()
    }
}
</script>

<style scoped>
.table-title {
    border: 1px solid #ccc;
    padding: 10px 20px;
    overflow: hidden;
    line-height: 28px;
    border-bottom: none;
    text-align: center;
    background: #eee;
    font-size: 14px;
}

td.caozuo {
    vertical-align: top;
}

td div {}

.invoice-table {
    width: 100%;
    border: 1px solid #ccc;
}

.invoice-table th,
.invoice-table td {
    border: 1px solid #ccc;
}

.invoice-table th {
    height: 40px;
    line-height: 40px;
    background: #eee;
}

.invoice-table td {
    padding: 5px 10px;
}

.el-card {
    background: none;
    margin-top: 20px;
    background: #fff;
}

/deep/ .el-card__header {
    font-size: 14px;
    font-weight: bold;
    padding: 15px 20px;
}

/deep/ .el-card__header .msg {
    font-size: 12px;
    color: red
}

.partial-invoice {
    display: flex;
    width: 180px;
}

.partial-invoice span {
    white-space: nowrap;
    width: 80px;
}

/deep/.required .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}

/deep/.el-table th.star div:before {
    content: '*';
    color: red;
}

.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.content-wapper {
    border: 1px solid #d6dbe5;
    border-radius: 3px;
    padding: 30px;
    padding-top: 15px;
    background: #fff;
}

.title {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin: 0 0 10px 0;
}

.info-wapper li {
    margin: 15px 0;
}

.info-wapper li div {
    display: inline-block;
    width: 400px;
    position: relative;
}

.info-wapper .special {
    width: 800px;
}

.info-wapper span {
    margin-left: 130px;
    display: inline-block;
    vertical-align: top;
}

.info-wapper label {
    color: #909399;
    display: inline-block;
    width: 100px;
    text-align: right;
    position: absolute;
    top: 0;
}

.textarea {
    display: inline-block;
    width: 500px;
}

.images-wapper {
    border-top: 1px dashed #909399;
    margin-top: 30px;
}

.info-wapper .el-image {
    width: 210px;
    height: 100px;
    border-radius: 6px;
    margin-left: 15px;
}

.table-wapper {
    margin-left: 130px;
    width: 550px;
}

.table-wapper label {
    padding: 10px 0;
    text-align: center;
    width: 100%;
    display: block;
    font-weight: bold;
    border: 1px solid #d6dbe5;
    border-bottom: none;
}

.table-wapper table {
    border: 1px solid #d6dbe5;
    width: 100%;
}

.table-wapper td {
    padding: 10px;
    border-bottom: 1px solid #d6dbe5;
    border-right: 1px solid #d6dbe5;
}

.table-wapper tr:first-child td {
    font-weight: bold;
    background: #f9f9f9;
}

.table-top {
    width: 100%;
    font-weight: bold;
    border: 1px solid #cdd0d6;
    border-bottom: none;
    height: 50px;
    background: #fff;
    padding-top: 15px;
    padding-left: 10px;
}

.info span {
    margin-top: 0;
    color: #ff5e5e;
}

.info {
    background-color: #f8eec0;
    padding: 15px;
}

.info ul li {
    margin: 10px 0;
}

.bottom {
    margin-top: 20px;
    display: flex;
    align-items: center;
}

.bottom-info {
    color: #ff5e5e;
}

.total {
    margin-left: 30px;
    font-weight: bold;
    display: flex;
}

.openInvoiceInfo {
    padding: 0 10px;
    margin-bottom: 20px;
    background-color: #f0f0f0;
}

.openInvoiceInfoList {
    margin-bottom: 20px;
}

.rightInfo {
    position: fixed;
    right: 0;
    font-weight: bold;
    color: rgb(252, 0, 0);
    top: 50%;
    text-align: center;

    height: 50px;
    border-radius: 50px 0 0 50px;
    z-index: 9;
    background-color: #c4c4c4;
}

.rightInfo div {
    padding: 0 10px;
    padding-top: 5px;
}

/deep/ .el-table .cell {
    white-space: normal;
}

.info {
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid rgb(226, 226, 226);
    flex-direction: column;
}

.info span:first-child {
    font-weight: bold;
    margin-bottom: 15px;
}

.one {
    font-weight: bold;
    margin-top: 20px;
}

.one span {
    margin-right: 20px;
}

.two {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top: 20px;
}

.two span:first-child {
    margin-right: 20px;
}
.tips{
    display:inline-block;
   line-height:30px;

}
.tips span{
    color:red;
}


</style>